export default __webpack_public_path__ + "static/media/jualineferraz.83679da5.jpg";